import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CTA, Modal, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import { SITE_NOTIFICATION_TOGGLE } from '../../../../app/redux/actions/notifications';
import CustomToggle from '../../CustomToggle';
import { SettingCard } from './style';

export const ModalGeneralSettingsId = 'ModalGeneralSettings';

const SingleToggle = ({ title, body, onChange, checked }) => (
  <SettingCard>
    <div>
      <Text type="h3.5" mb={4}>
        {title}
      </Text>
      <Text type="b4">{body}</Text>
    </div>
    <div onClick={onChange}>
      <CustomToggle checked={checked} />
    </div>
  </SettingCard>
);

SingleToggle.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
};

const defaultToggles = {
  // courses
  course_registration_notification: false,
  course_reminder_notification: false,
  course_activities_up_notification: false,
  course_tutor_reply_notification: false,
  // events
  event_registration_notification: false,
  event_reminder_notification: false,
  // newsletter
  newsletter_sent_notification: false,
  // news
  news_published_notification: false,
};

const ModalGeneralSettings = ({
  mediaIsPhone,
  isOpen,
  id,
  modalClose,
  user,
  setNotificationSite,
}) => {
  const scrollableAreaRef = useRef(null);
  const [toggles, setToggles] = useState(defaultToggles);

  const handleOnChange = (key = '', value) => {
    const newToggles = { ...toggles };
    newToggles[key] = value;
    setToggles(newToggles);
  };

  useEffect(() => {
    if (isOpen && id === ModalGeneralSettingsId) {
      const newToggles = { ...toggles };
      const preferences = user?.notification_preferences || {};
      // courses
      newToggles.course_registration_notification =
        preferences.course_registration_notification;
      newToggles.course_reminder_notification =
        preferences.course_reminder_notification;
      newToggles.course_activities_up_notification =
        preferences.course_activities_up_notification;
      newToggles.course_tutor_reply_notification =
        preferences.course_tutor_reply_notification;
      // event
      newToggles.event_registration_notification =
        preferences.event_registration_notification;
      newToggles.event_reminder_notification =
        preferences.event_reminder_notification;
      // newsletter
      newToggles.newsletter_sent_notification =
        preferences.newsletter_sent_notification;
      // news
      newToggles.news_published_notification =
        preferences.news_published_notification;
      setToggles(newToggles);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, id, user]);

  const formatBody = (body) => {
    return {
      course_registration: body.course_registration_notification,
      course_reminder: body.course_reminder_notification,
      course_activities_up: body.course_activities_up_notification,
      course_tutor_reply: body.course_tutor_reply_notification,
      event_registration: body.event_registration_notification,
      event_reminder: body.event_reminder_notification,
      news_published: body.news_published_notification,
      newsletter_sent: body.newsletter_sent_notification,
    };
  };

  return (
    <Modal
      title="Impostazioni Generali"
      modalId={ModalGeneralSettingsId}
      scrollableAreaRef={scrollableAreaRef}
    >
      <ScrollableArea
        ref={scrollableAreaRef}
        style={{ minWidth: 'min(1020px, 60vw)' }}
      >
        <Text type="h2" mb={8}>
          Percorsi formativi
        </Text>
        <SingleToggle
          title="Attiva notifiche sull’iscrizione dei corsi"
          body="Ricevi un avviso di conferma una volta effettuata l’iscrizione ad
            un corso"
          onChange={() => {
            handleOnChange(
              'course_registration_notification',
              !toggles.course_registration_notification
            );
          }}
          checked={toggles.course_registration_notification}
        />
        <SingleToggle
          title="Attiva notifiche sulla scadenza dei corsi"
          body="Ricevi un avviso quando un corso a cui sei iscritto sta per scadere"
          onChange={() => {
            handleOnChange(
              'course_reminder_notification',
              !toggles.course_reminder_notification
            );
          }}
          checked={toggles.course_reminder_notification}
        />
        <SingleToggle
          title="Attiva notifiche sulla modifica delle attività"
          body="Ricevi un avviso quando una o più attività di un corso vengono modificate"
          onChange={() => {
            handleOnChange(
              'course_activities_up_notification',
              !toggles.course_activities_up_notification
            );
          }}
          checked={toggles.course_activities_up_notification}
        />
        <SingleToggle
          title="Attiva notifiche sulle risposte ad un commento"
          body="Ricevi un avviso quando un tutor risponde ad un tuo commento"
          onChange={() => {
            handleOnChange(
              'course_tutor_reply_notification',
              !toggles.course_tutor_reply_notification
            );
          }}
          checked={toggles.course_tutor_reply_notification}
        />
        <Text type="h2" mt={24} mb={8}>
          Comunicazione
        </Text>
        <SingleToggle
          title="Attiva notifiche sulle comunicazioni"
          body="Ricevi un avviso sulle nuove comunicazioni pubblicate"
          onChange={() => {
            handleOnChange(
              'news_published_notification',
              !toggles.news_published_notification
            );
          }}
          checked={toggles.news_published_notification}
        />
        <SingleToggle
          title="Attiva notifiche sulle newsletter"
          body="Ricevi un avviso sulle nuove newsletter pubblicate"
          onChange={() => {
            handleOnChange(
              'newsletter_sent_notification',
              !toggles.newsletter_sent_notification
            );
          }}
          checked={toggles.newsletter_sent_notification}
        />
        <Text type="h2" mt={24} mb={8}>
          Eventi
        </Text>
        <SingleToggle
          title="Attiva notifiche sugli eventi"
          body="Ricevi un avviso di conferma una volta effettuata l’iscrizione ad
          un evento"
          onChange={() => {
            handleOnChange(
              'event_registration_notification',
              !toggles.event_registration_notification
            );
          }}
          checked={toggles.event_registration_notification}
        />
        <SingleToggle
          title="Attiva promemoria sugli eventi"
          body="Ricevi un promemoria quando un evento a cui sei iscritto sta per iniziare"
          onChange={() => {
            handleOnChange(
              'event_reminder_notification',
              !toggles.event_reminder_notification
            );
          }}
          checked={toggles.event_reminder_notification}
        />
      </ScrollableArea>
      <Footer>
        <CTA
          type="secondary"
          btnText="annulla"
          fullsize={mediaIsPhone}
          onClick={() => {
            setToggles(defaultToggles);
            modalClose();
          }}
        />
        <CTA
          type="primary"
          btnText="Applica"
          fullsize={mediaIsPhone}
          onClick={() => {
            setNotificationSite({
              body: formatBody(toggles),
            });
            setToggles(defaultToggles);
            modalClose();
          }}
        />
      </Footer>
    </Modal>
  );
};

ModalGeneralSettings.propTypes = {
  mediaIsPhone: PropTypes.bool,
  isOpen: PropTypes.bool,
  id: PropTypes.string,
  user: PropTypes.object,
  modalClose: PropTypes.func.isRequired,
  setNotificationSite: PropTypes.func,
};

export default compose(
  connect(
    (state) => {
      const { isOpen, id } = state.app.modal;
      const { user } = state;
      return {
        id,
        isOpen,
        user,
      };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      setNotificationSite: ({ body }) =>
        dispatch({ type: SITE_NOTIFICATION_TOGGLE._REQUEST, body }),
    })
  ),
  withMediaQueries
)(ModalGeneralSettings);
